import React, { Component, ReactNode } from 'react';
import PropTypes from 'prop-types';
import { LoggerFactory } from 'Services/Logger';
import { ErrorBoundaryProps, ErrorWithTrace } from './ErrorBoundary.types';

class ErrorBoundary extends Component<ErrorBoundaryProps> {
  static propTypes = {
    children: PropTypes.node.isRequired,
    loggingDomain: PropTypes.string.isRequired,
    loggingFeature: PropTypes.string.isRequired,
    onErrorElement: PropTypes.element.isRequired,
  };

  static defaultProps = {
    onErrorElement: null,
  };

  static getDerivedStateFromError(error: Error) { return { error }; }

  override state = { error: undefined };

  override componentDidCatch(error: ErrorWithTrace) {
    const { loggingFeature, loggingDomain } = this.props;
    const logger = LoggerFactory.getLogger(loggingDomain);
    const hasTrace = 'trace' in error;

    const logMessage = `ErrorBoundary: ${error.message}`;

    const logData = {
      error: {
        name: error.name,
        message: error.message,
        stack: error.stack,
        ...(hasTrace && { trace: error.trace }),
      },
      navigation: { path: window.location.pathname },
    };

    logger.error(
      logMessage,
      loggingFeature,
      logData
    );
  }

  override render() {
    const { children, onErrorElement } = this.props;
    const { error } = this.state;

    return error ? onErrorElement : children;
  }
}

export default ErrorBoundary;
